export function post(url, data = {}) {
    if (data instanceof HTMLFormElement) data = Object.fromEntries(new FormData(data));
    data.csrf_token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        body: JSON.stringify(data)
    })
        .then(response => response.text())
        .then(text => {
            try {
                return JSON.parse(text);
            } catch (error) {
                return text;
            }
        })
}

const duration = 300;
Element.prototype.fadeIn = function(display = 'block')  {
    const computedStyle = window.getComputedStyle(this);
    const isVisible = computedStyle.display !== 'none' && parseFloat(computedStyle.opacity) === 1;

    if (isVisible) {
        return Promise.resolve();
    }

    this.style.display = display;

    const animation = this.animate([
        {opacity: 0},
        {opacity: 1}
    ], {
        duration: duration,
        easing: 'ease-in-out',
        fill: 'forwards'
    });

    return animation.finished;
};

Element.prototype.fadeOut = function() {
    const computedStyle = window.getComputedStyle(this);
    const isHidden = computedStyle.display === 'none' || parseFloat(computedStyle.opacity) === 0;

    if (isHidden) {
        this.style.display = 'none';
        return Promise.resolve();
    }

    const animation = this.animate([
        {opacity: 1},
        {opacity: 0}
    ], {
        duration: duration,
        easing: 'ease-in-out',
        fill: 'forwards'
    });

    return animation.finished.then(() => {
        this.style.display = 'none';
    });
};